const Marionette = require('lib/marionette')
const BaseModel = require('lib/base_model')
const radio = require('lib/radio')

const log = require('log').create('dialog', 'state'); // eslint-disable-line

const channel = radio.dialog

/**
    singleton class for tracking how many dialogs are open
    not meant to be used directly
    the API for this is entirely through the radio.dialog channel
*/


const DialogState = Marionette.MnObject.extend({

    initialize() {

        this.model = new BaseModel({
            count: 0,
        })

        channel.reply('count', () => {
            return this.model.get('count')
        }, this)

        channel.reply('dialog:is:open', () => {
            return this.model.get('count') > 0
        }, this)

        this.listenTo(this.model, 'change:count', (model, count) => {
            log('count', count)
            channel.trigger('change:count', count)
        })

        this.listenTo(channel, 'dialog:open', () => {
            this.incrementCount()
        })

        this.listenTo(channel, 'dialog:close', () => {
            this.decrementCount()
        })

    },

    incrementCount() {
        log('incrementCount')
        const count = this.model.get('count')
        this.model.set('count', count + 1)
    },

    decrementCount() {
        log('decrementCount')
        const count = this.model.get('count')
        this.model.set('count', count - 1)
    },

})

module.exports = new DialogState()
